import SharedAsset from '@zenbusiness/zui/SharedAsset';
import PropTypes from 'prop-types';

import { TRANSACTION_DIRECTION } from '#client/constants/transaction';

import { IconBorderStyled } from './styles';

const Icon = ({ direction, isPayment }) => {
  const { DEBIT, CREDIT } = TRANSACTION_DIRECTION;
  const NorthEastIcon = (
    <SharedAsset
      alt=""
      src="/s2/icon/arrow-top-right-fill.svg"
    />
  );
  const SouthEastIcon = (
    <SharedAsset
      alt=""
      src="/s2/icon/arrow-bottom-right-fill.svg"
    />
  );
  const mappingIcon = {
    [DEBIT]: isPayment ? SouthEastIcon : NorthEastIcon,
    [CREDIT]: isPayment ? NorthEastIcon : SouthEastIcon
  };

  return mappingIcon[direction];
};

Icon.propTypes = {
  direction: PropTypes.string.isRequired,
  isPayment: PropTypes.bool
};

export default function DirectionTypeIcon({ direction, isPayment = false }) {
  const icon = (
    <Icon
      direction={direction}
      isPayment={isPayment}
    />
  );

  return <IconBorderStyled aria-label="icon-wrapper">{icon}</IconBorderStyled>;
}

DirectionTypeIcon.propTypes = {
  direction: PropTypes.string.isRequired,
  isPayment: PropTypes.bool
};
